import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { EnvironmentService } from '../environment/environment.service';
import { AuthUser } from '../auth/auth-frame/auth-user.model';


const sessionApiUrl = "/validateSession";
const sessionUpdateApiUrl = "/update-session";

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private apiUrl: string;
  private authKey: string;
  private sessionState: string;
  isSessionExpired: boolean = false;

  constructor(private environmentService: EnvironmentService, private http: HttpClient, private sanitizer: DomSanitizer) {
    this.apiUrl = this.environmentService.envModel.appSettings.apiUrlSession;
    this.sessionState = this.environmentService.envModel.sessionState;
    this.authKey = this.environmentService.envModel.authSettings.authKey;
  }

  setSessionState(state: string): void {
    sessionStorage.setItem(this.sessionState, state);
  }

  setToken(token: string): boolean {
    if (!token)
      return false;

    localStorage.setItem(this.authKey, token);
    return true;
  }

  retrieveToken(): string {
    return localStorage.getItem(this.authKey);
  }

  removeToken(): void {
    localStorage.removeItem(this.authKey);
  }

  verifySessionState(): boolean {
    if (!sessionStorage.getItem(this.sessionState) || sessionStorage.getItem(this.sessionState) == 'false')
      return false;

    return true;
  }

  getSessionState(jwt: string, idConexao: string): Observable<boolean> {

    const URL = this.apiUrl + sessionApiUrl;
    const headers = new HttpHeaders({ jwt, id_conexao: idConexao });
    return this.http.get<boolean>(URL, { headers });
  }

  updateSession(): Observable<string> {
    return this.http.get(this.apiUrl + sessionUpdateApiUrl, { responseType: 'text' });
  }

  expireSession(): void {
    this.setSessionState('false');
    this.isSessionExpired = true;
    this.removeToken();
    this.removeAuthUser();
  }

  timeoutSession(): void {
    if (this.verifySessionState()) {
      this.expireSession();
    }
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getAuthUser(): AuthUser {
    return JSON.parse(localStorage.getItem('authUser'));
  }

  setAuthUser(authUser: AuthUser): void {
    localStorage.setItem('authUser', JSON.stringify(authUser));
  }

  removeAuthUser(): void {
    localStorage.removeItem('authUser');
  }

  isUserLogged(): boolean {
    let token: string = this.retrieveToken();
    let authUser: AuthUser = this.getAuthUser();

    if (!token || token === '' || authUser == null)
      return false;

    return true;
  }

}
